import * as React from 'react';
import {
  Box,
  Button,
  Chip,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { ClockIcon, DotsIcon, ExportIcon, EyeIcon, UsersIcon, } from '../icons';
import { GlobalStyles } from '@mui/material';
import AssignCouncilorModal from '../components/councilor/AssignCouncilorModal';
import { useState } from 'react';
import UpdateStatusModal from '../components/CourseCallScheduleAdmin/UpdateStatusModal';
import RescheduleCallModal from '../components/CourseCallScheduleAdmin/RescheduleCallModal';
import RequestDetailsModal from '../components/CourseCallScheduleAdmin/RequestDetailsModal';
import { formatMultiQueryParams, getIcon, jsonParserFormatter } from '../utils/helperFunction';
import { useDispatch } from 'react-redux';
import { setCouncilorList, setSelectedScheduleCall } from '../containers/schedule-call-container/reducer/scheduleCallSlice';
import { assignCouncilorToCall, fetchCallScheduleList, fetchCouncilorList } from '../api/callScheduleApi';
import { useNotification } from '../hooks/useNotification';
import CommonTableFormat from '../components/common/CommonTableFormat';
import CommonFilterTab from '../components/common/CommonFilterTab';
import { setPaginationFiled } from '../containers/pagination-container/reducer/paginationSlice';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { defaultPaginationValues, filterTypeOptions, webLeadsStatusList } from '../utils/constant';
import { setFilterField } from '../containers/filter-container/reducer/filterSlice';
import CommonDataTable from '../components/common/CommonDataTable';

const CourseCallScheduleAdmin = ({ activeTab }) => {
  const filterSlice = useSelector(state => state.filter?.filters)
  const LOCATION_FILTER = `filters_${activeTab}:${window.location.pathname}`
  const dispatch = useDispatch()
  const scheduleCallSlice = useSelector(state => state.schedulecall)
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [searchText, setSearchText] = React.useState('');
  const [selectedStatus, setSelectedStatus] = React.useState('');
  const [assignOpen, setAssignOpen] = useState(false);
  const [updateStatusOpen, setUpdateStatusOpen] = useState(false);
  const [rescheduleCallOpen, setRescheduleCallOpen] = useState(false);
  const [requestDetailsOpen, setRequestDetailsOpen] = useState(false);
  const { showErrorNotification, } = useNotification()
  const [rowCount, setRowCount] = useState(0);
  const [searchFilter, setSearchFilter] = React.useState({})
  const [pageFilters, setPageFilters] = React.useState(defaultPaginationValues);
  const [isRender, setIsRender] = React.useState(false)

  const handleFliterSliceChange = (values = {}, isReset = false) => {
    let isQuery = typeof values === "object" && Object.keys(values)?.length
    isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
  }

  const fetchDetails = () => {
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchCallScheduleList({ setRows, filterData: { ...searchFilter, ...multiFilter, isMultiFilter: true }, setRowCount })
      .then(res => {
        setLoading(false)
      }).catch(error => {
        showErrorNotification(error?.message)
      })
  }

  React.useEffect(() => {
    fetchDetails()
  }, [filterSlice[LOCATION_FILTER], isRender])


  // handle extra filter tabs changes
  React.useEffect(() => {
    if (pageFilters?.page) {
      handleFliterSliceChange({ page: 0 })
    } else {
      setIsRender(!isRender)
    }
  }, [searchFilter])

  // parse page filters
  React.useEffect(() => {
    const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
    setPageFilters(values)
  }, [filterSlice[LOCATION_FILTER]])


  // Status colors mapping
  const statusStyles = {
    completed: {
      text: '#1b5e20', // Dark green
      bg: '#c8e6c9',   // Light green
    },
    pending: {
      text: '#ff9800', // Orange
      bg: '#fff3e0',   // Light orange
    },
    'scheduled': {
      text: '#1565c0', // Blue
      bg: '#e3f2fd',   // Light blue
    },
    cancelled: {
      text: '#b71c1c', // Dark red
      bg: '#ffcdd2',   // Light red
    },
  };


  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: false,
      // renderCell: (params) => rows?.findIndex((r) => r.id === params.row.id) + 1,
    },
    {
      field: 'requestID',
      headerName: 'Request ID',
      flex: 1,
      minWidth: 130,
      cellClassName: 'sticky-col-1',
      headerClassName: 'sticky-col-1',
      filterColumnName: "requestId",
      filterType: filterTypeOptions.string,
    },

    {
      field: 'studentDetails',
      headerName: 'Student Details',
      flex: 2,
      minWidth: 280,
      filterColumnName: "userId.fullName",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { img, studentDetails } = params.row;

        const getInitials = (fullName) => {
          if (!fullName) return '';
          const words = fullName.trim().split(' ').filter(Boolean);
          if (words.length === 1) return words[0][0]?.toUpperCase() || '';
          if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
          return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
        };

        const stringToColor = (str) => {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
          }
          const c = (hash & 0x00ffffff).toString(16).toUpperCase();
          return '#' + '00000'.substring(0, 6 - c.length) + c;
        };

        const bgColor = stringToColor(studentDetails || 'Course');

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
          >
            {img ? (
              <Box
                component="img"
                src={img}
                alt="logo"
                sx={{
                  width: 40,
                  height: 40,
                  padding: '5px',
                  borderRadius: '50%',
                  objectFit: 'contain',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                  display: 'block',
                  maxHeight: 60,
                }}
              />
            ) : (
              <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: bgColor,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '10px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(studentDetails)}
              </Box>
            )}
            {params.value}
          </Box>
        );
      },
    },

    {
      field: 'phoneNumber',
      headerName: 'Phone Number',
      flex: 1.2,
      minWidth: 160,
      cellClassName: 'fw-bold',
      filterColumnName: "userId.phone",
      filterType: filterTypeOptions.string,
    },
    {
      field: 'emailID',
      headerName: 'Email ID',
      flex: 1,
      minWidth: 180,
      filterColumnName: "userId.email",
      filterType: filterTypeOptions.string,
    },
    {
      field: 'university',
      headerName: 'Course & University',
      flex: 2,
      minWidth: 260,
      filterColumnName: "refId.universityName",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { universityName, course } = params.row;

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box display="flex" sx={{ height: '100%', flexDirection: 'column', justifyContent: 'center', }}>
            {/* University Name */}
            <Typography sx={{ fontSize: '13px !important', color: '#1075FF', fontWeight: 500 }}>
              {course}
            </Typography>

            {/* Course Name */}
            <Typography
              sx={{
                fontSize: '11px !important',
                fontWeight: 500,
                color: '#6E7485',
                paddingTop: '4px',
              }}
            >
              {universityName}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'source',
      headerName: 'Source',
      flex: 1.2,
      minWidth: 160,
      filterColumnName: "source",
      filterType: filterTypeOptions.string,
    },

    {
      field: "requestType",
      headerName: "Request Type",
      flex: 1,
      minWidth: 150,
      filterColumnName: "callType",
      filterType: filterTypeOptions.string,
      renderCell: (params) => (
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'start', height: '100%' }}>
          <Button
            size="small"
            variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', px: '0' }}
            startIcon={getIcon(params?.row?.callType)}
          >
          </Button>
        </Stack>
      ),
    },


    {
      field: 'preferredCallTime',
      headerName: 'Preferred Call Time',
      flex: 1,
      minWidth: 130,
      cellClassName: "fw-bold",
      filterColumnName: "dateTime",
      filterType: filterTypeOptions.dateRange,
      renderCell: (params) => {
        const { preferredDate, preferredTime } = params.row;
        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box display="flex" sx={{ height: '100%', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            {/* University Name */}
            <Typography sx={{ fontSize: '13px !important', color: '#363853', fontWeight: 500 }}>
              {preferredDate}
            </Typography>

            {/* Course Name */}
            <Typography
              sx={{
                fontSize: '11px !important',
                fontWeight: 500,
                color: '#6E7485',
                paddingTop: '4px',
              }}
            >
              {preferredTime}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 130,
      headerClassName: 'text-center',
      cellClassName: 'text-center',
      filterColumnName: "status",
      filterType: filterTypeOptions.selection,
      selection: webLeadsStatusList,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={70} />
        ) : (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: statusStyles[params.value]?.bg || '#eee',
              color: statusStyles[params.value]?.text || '#000',
              fontWeight: 500,
              textTransform: 'capitalize'
            }}
          />
        ),
    },
    {
      field: 'submitted',
      headerName: 'Submitted',
      flex: 1,
      minWidth: 130,
      cellClassName: "fw-bold",
      filterColumnName: "createdAt",
      filterType: filterTypeOptions.dateRange,
    },

    {
      field: 'assignedTo',
      headerName: 'Assigned To',
      flex: 2,
      minWidth: 180,
      filterColumnName: "counselorId.firstName",
      filterType: filterTypeOptions.string,
      renderCell: (params) => {
        const { img, assignedTo } = params.row;

        const getInitials = (fullName) => {
          if (!fullName) return '';
          const words = fullName?.trim().split(' ').filter(Boolean);
          if (words.length === 1) return words[0][0]?.toUpperCase() || '';
          if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
          return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
        };

        const stringToColor = (str) => {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
          }
          const c = (hash & 0x00ffffff).toString(16).toUpperCase();
          return '#' + '00000'.substring(0, 6 - c.length) + c;
        };

        const bgColor = stringToColor(assignedTo || 'Course');

        return loading ? (
          <Skeleton width={150} />
        ) : (
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
          >
            {img ? (
              <Box
                component="img"
                src={img}
                alt="logo"
                sx={{
                  width: 40,
                  height: 40,
                  padding: '5px',
                  borderRadius: '50%',
                  objectFit: 'contain',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                  display: 'block',
                  maxHeight: 60,
                }}
              />
            ) : (
              assignedTo ? <Box
                sx={{
                  minWidth: 35,
                  minHeight: 35,
                  maxWidth: 35,
                  maxHeight: 35,
                  borderRadius: '50%',
                  backgroundColor: bgColor,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 500,
                  fontSize: '10px',
                  textTransform: 'uppercase',
                  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                }}
              >
                {getInitials(assignedTo)}
              </Box> : ""
            )}
            {params.value}
          </Box>
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 250,
      filterable: false,
      renderCell: (params) =>
        loading ? <Skeleton width={80} /> : <Stack direction="row" spacing={1} sx={{ justifyContent: 'start', height: '100%' }}>
          <Button onClick={() => { setUpdateStatusOpen(true); dispatch(setSelectedScheduleCall(params?.row)) }}
            size="small"
            variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
            startIcon={<DotsIcon />}
          >

          </Button>
          <Button onClick={() => { setRequestDetailsOpen(true); dispatch(setSelectedScheduleCall(params?.row)) }}
            size="small"
            variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
            startIcon={<EyeIcon />}
          >

          </Button>
          <Button onClick={() => { setRescheduleCallOpen(true); dispatch(setSelectedScheduleCall(params?.row)) }}
            size="small"
            variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
            startIcon={<ClockIcon />}
          >

          </Button>
          <Button onClick={() => { setAssignOpen(true); dispatch(setSelectedScheduleCall(params?.row)) }}
            size="small"
            variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
            startIcon={<UsersIcon />}
          >

          </Button>
        </Stack>,
    },

  ];

  const assignCounsilorInfo = {
    _id: scheduleCallSlice?.selectedScheduleCall?.id,
    student: scheduleCallSlice?.selectedScheduleCall?.studentDetails,
    universityName: scheduleCallSlice?.selectedScheduleCall?.universityName,
    status: scheduleCallSlice?.selectedScheduleCall?.status,
    preferredDate: scheduleCallSlice?.selectedScheduleCall?.preferredDate,
    preferredTime: scheduleCallSlice?.selectedScheduleCall?.preferredTime,
  }
  return (
    <>
      {/* Apply global styles to DataGrid dropdown menus */}
      {/* <GlobalStyles
        styles={{
          '.MuiDataGrid-menuList': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiDataGrid-panelContent': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiSelect-select': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiList-root .MuiButtonBase-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
            fontSize: '13px',
          },
          '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiTypography-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root': {
            fontSize: '13px',
            padding: '6px 12px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
            backgroundColor: '#f5f5f5',
          },
          '& .MuiDataGrid-columnHeaders': {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: '#fff',
          },
          '& .MuiDataGrid-cell.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 2,
          },
          '& .MuiDataGrid-columnHeader.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 3, // slightly higher than cell
          },
        }}
      /> */}

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', marginBottom: '12px' }}>
          <div className="row align-items-center">
            <div className="col">
              <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}>
                {/* <Link href="/university-listing-management" className='d-flex'><BackArrowIcon /></Link> */}

                Course Call Schedule</Typography>
            </div>
            {/* End Col */}
          </div>
          {/* End Col */}
        </div>
        {/* Filter Toolbar */}

        {/* filter tab */}
        <CommonFilterTab type='schedule-call' module='admin' searchPlaceholder='Search by ID/Moblie/Name...' detailType='Call Requests Overview' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount}
        />

        {/* Data Table */}
        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
          pageFilters={pageFilters}
          handleFliterSliceChange={handleFliterSliceChange}
          otherPath={activeTab}
        />

      </Box>

      <AssignCouncilorModal refetch={fetchDetails} open={assignOpen} assignCouncilorToCall={assignCouncilorToCall} onClose={() => setAssignOpen(false)} info={assignCounsilorInfo} />
      <UpdateStatusModal refetch={fetchDetails} open={updateStatusOpen} onClose={() => setUpdateStatusOpen(false)} />
      <RescheduleCallModal refetch={fetchDetails} open={rescheduleCallOpen} onClose={() => setRescheduleCallOpen(false)} />
      <RequestDetailsModal open={requestDetailsOpen} onClose={() => setRequestDetailsOpen(false)} />
    </>
  )
}

export default CourseCallScheduleAdmin
